export default __webpack_public_path__ + "static/media/Renogare-Regular.156af8ed.woff";